export const AdminPermissionLevel = {
  SuperAdmin: "Super Admin",
  Admin: "Admin",
  Editor: "Editor",
  Viewer: "Viewer",
};
